<template>
  <div class="home-layout">
    <child class="main-content" />
    <footer id="footer">
      <div id="footer-content">
        Provo, UT 84602, USA | © 2023 Brigham Young University
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HomeLayout',
  created() {
    // clear back to pcs for settings
    localStorage.removeItem('latestPCS')
  }
}
</script>

<style scoped lang="scss">
.home-layout {
  min-height: 100vh;
  overflow-y: auto;
  background-color: white;
  display: flex;
  flex-flow: column;
  margin: 0;
}

.main-content {
  flex: 1;
}

#footer {
  background-color: var(--home-primary);
  color: white;
  min-height: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#footer-content {
  padding: 2em;
}
</style>